var r="@hpstellar/core/drop-down";export{r as dropdownTestId};
